import { apolloVuexListStoreFactory } from '../../../libs/ApolloVuexListStore'

import { SHIPPING_LINES_QUERY } from "./graphql";

/* eslint-disable no-unused-vars */
const store = apolloVuexListStoreFactory({
  settings: {
    fetchAllQuery: SHIPPING_LINES_QUERY,
    fetchAllFieldName: 'shippingLines',
  },
})
/* eslint-enable no-unused-vars */

export default store

